var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Play Button"),React.createElement("g",{"id":"Play-Button","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"id":"Group","fill":"#FFFFFF","fillOpacity":"0.9","key":0},React.createElement("circle",{"id":"Combined-Shape","cx":"22.5","cy":"22.5","r":"22.5"})),React.createElement("polygon",{"id":"Triangle","fill":"#26B8CE","transform":"translate(24.709247, 22.500000) rotate(-270.000000) translate(-24.709247, -22.500000) ","points":"24.7092471 12.375 34.8342471 32.625 14.5842471 32.625","key":1})])]);
}

PlayButton.defaultProps = {"width":"45px","height":"45px","viewBox":"0 0 45 45","version":"1.1"};

module.exports = PlayButton;

PlayButton.default = PlayButton;



//////////////////
// WEBPACK FOOTER
// ./app/components/support/play-button.svg
// module id = ./app/components/support/play-button.svg
// module chunks = 1